import React from 'react'

import HeroBanner from '../components/hero-banner'
import HeroBannerContact from '../components/hero-banner-contact'
import HeroBannerAbout from '../components/hero-banner-about'
import HeroBannerTeam from '../components/hero-banner-team'
import HeroBannerAppraisal from '../components/hero-banner-appraisal'
import HeroBannerOffMarket from '../components/hero-banner-off-market'
import PropertyOptions from '../components/property-options'
import LatestProperties from '../components/latest-properties'
import WhyUsShowcase from '../components/why-us-showcase'
import MediaOutlets from '../components/media-outlets'
import FeaturedNews from '../components/featured-news'
import SignOff from '../components/sign-off'
import ThankYou from '../components/thank-you'
import BasicContent from '../components/basic-content'
import TeamBlock from '../components/team-block'
import Contact from '../components/contact'
import Embed from '../components/embed'
import LocationBlock from '../components/location-block'
import FeatureHighlights from '../components/feature-highlights'
import FeatureTestimonial from '../components/feature-testimonial'
import AchievementsBlock from '../components/achievements-block'
import BusinessData from '../components/business-data'
import WhyUsList from '../components/why-us-list'
import FullImage from '../components/full-image'
import AboutTheArea from '../components/about-the-area'
import TestimonialsBlock from '../components/testimonials-block'
import FeaturedTeamMembers from '../components/featured-team-members'
import TeamMembers from '../components/team-members'
import OurPartnershipsBlock from '../components/our-partnerships-block'
import Suburbs from '../components/suburbs'
import News from '../components/news'
import KolloscheTv from '../components/kollosche-tv'
import Timeline from '../components/timeline'
import Divisions from '../components/divisions'
import Video from '../components/video'
import Faqs from '../components/faqs'
import Guides from '../components/guides'
import Stats from '../components/stats'
import Support from '../components/support'
import Opportunities from '../components/opportunities'
import Community from '../components/community'
import CurrentListings from '../components/current-listings'
import CurrentAgentListings from '../components/current-agent-listings'
import TimedAuctions from '../components/timed-auctions'
import Projects from '../components/projects'
import AgentProfileTeam from '../components/agent-profile-team'
import AgentProfileAwards from '../components/agent-profile-awards'
import AgentProfileImageContent from '../components/agent-profile-image-content'
import AgentProfileContact from '../components/agent-profile-contact'
import AgentProfileAbout from '../components/agent-profile-about'
import AgentProfileProperties from '../components/agent-profile-properties'
import AgentProfileHeroBanner from '../components/agent-profile-hero-banner'
import AgentFullWidthButton from '../components/agent-full-width-button'
import AgentPodcast from '../components/agent-podcast'
import AgentVideos from '../components/agent-videos'
import AgentPostsBlock from '../components/agent-posts-block'
import AgentPosts from '../components/agent-posts'
import ContactPopup from '../components/contact-popup'

const renderBlock = (param, el, i, postType, func=null) => {

  param = param?.replace(postType, '')

  let block = {
  	'_Acf_ContentBlocks_HeroBanner' : (el, i) => <HeroBanner key={i} {...el} />,
    '_Acf_ContentBlocks_HeroBannerContact' : (el, i) => <HeroBannerContact key={i} {...el} />,
    '_Acf_ContentBlocks_HeroBannerAbout' : (el, i) => <HeroBannerAbout key={i} {...el} />,
    '_Acf_ContentBlocks_HeroBannerTeam' : (el, i) => <HeroBannerTeam key={i} {...el} />,
    '_Acf_ContentBlocks_HeroBannerAppraisal' : (el, i) => <HeroBannerAppraisal key={i} {...el} />,
    '_Acf_ContentBlocks_HeroBannerOffMarket' : (el, i) => <HeroBannerOffMarket key={i} {...el} />,
    '_Acf_ContentBlocks_PropertyOptions' : (el, i) => <PropertyOptions key={i} {...el} />,
    '_Acf_ContentBlocks_LatestProperties' : (el, i) => <LatestProperties key={i} {...el} />,
    '_Acf_ContentBlocks_WhyUsShowcase' : (el, i) => <WhyUsShowcase key={i} {...el} />,
    '_Acf_ContentBlocks_MediaOutlets' : (el, i) => <MediaOutlets key={i} {...el} />,
    '_Acf_ContentBlocks_FeaturedNews' : (el, i) => <FeaturedNews key={i} {...el} />,
    '_Acf_ContentBlocks_Embed' : (el, i) => <Embed key={i} {...el} />,
    '_Acf_ContentBlocks_SignOff' : (el, i) => <SignOff key={i} {...el} />,
    '_Acf_ContentBlocks_ThankYou' : (el, i) => <ThankYou key={i} {...el} />,
    '_Acf_ContentBlocks_TeamBlock' : (el, i) => <TeamBlock key={i} {...el} />,
    '_Acf_ContentBlocks_BasicContent' : (el, i) => <BasicContent key={i} {...el} />,
    '_Acf_ContentBlocks_Contact' : (el, i) => <Contact key={i} {...el} />,
    '_Acf_ContentBlocks_LocationBlock' : (el, i) => <LocationBlock key={i} {...el} />,
    '_Acf_ContentBlocks_FeatureHighlights' : (el, i) => <FeatureHighlights key={i} {...el} />,
    '_Acf_ContentBlocks_FeatureTestimonial' : (el, i) => <FeatureTestimonial key={i} {...el} />,
    '_Acf_ContentBlocks_AchievementsBlock' : (el, i) => <AchievementsBlock key={i} {...el} />,
    '_Acf_ContentBlocks_BusinessData' : (el, i) => <BusinessData key={i} {...el} />,
    '_Acf_ContentBlocks_WhyUsList' : (el, i) => <WhyUsList key={i} {...el} />,
    '_Acf_ContentBlocks_FullImage' : (el, i) => <FullImage key={i} {...el} />,
    '_Acf_ContentBlocks_CurrentListings' : (el, i) => <CurrentListings key={i} {...el} />,
    '_Acf_ContentBlocks_CurrentAgentListings' : (el, i) => <CurrentAgentListings key={i} {...el} />,
    '_Acf_ContentBlocks_TimedAuctions' : (el, i) => <TimedAuctions key={i} {...el} />,
    '_Acf_ContentBlocks_AboutTheArea' : (el, i) => <AboutTheArea key={i} {...el} />,
    '_Acf_ContentBlocks_TestimonialsBlock' : (el, i) => <TestimonialsBlock key={i} {...el} />,
    '_Acf_ContentBlocks_FeaturedTeamMembers' : (el, i) => <FeaturedTeamMembers key={i} {...el} />,
    '_Acf_ContentBlocks_TeamMembers' : (el, i) => <TeamMembers key={i} {...el} />,
    '_Acf_ContentBlocks_OurPartnershipsBlock' : (el, i) => <OurPartnershipsBlock key={i} {...el} />,
    '_Acf_ContentBlocks_Suburbs' : (el, i) => <Suburbs key={i} {...el} />,
    '_Acf_ContentBlocks_News' : (el, i) => <News key={i} {...el} />,
    '_Acf_ContentBlocks_KolloscheTv' : (el, i) => <KolloscheTv key={i} {...el} />,
    '_Acf_ContentBlocks_Timeline' : (el, i) => <Timeline key={i} {...el} />,
    '_Acf_ContentBlocks_Divisions' : (el, i) => <Divisions key={i} {...el} />,
    '_Acf_ContentBlocks_Video' : (el, i) => <Video key={i} {...el} />,
    '_Acf_ContentBlocks_NewStats' : (el, i) => <Stats key={i} {...el} />,
    '_Acf_ContentBlocks_Faqs' : (el, i) => <Faqs key={i} {...el} />,
    '_Acf_ContentBlocks_Guides' : (el, i) => <Guides key={i} {...el} />,
    '_Acf_ContentBlocks_Support' : (el, i) => <Support key={i} {...el} />,
    '_Acf_ContentBlocks_Opportunities' : (el, i) => <Opportunities key={i} {...el} />,
    '_Acf_ContentBlocks_CommunityForm' : (el, i) => <Community key={i} {...el} />,
    '_Acf_ContentBlocks_Projects' : (el, i) => <Projects key={i} {...el} />,
    '_Acf_ContentBlocks_AgentPosts' : () => <AgentPosts key={i} {...el} />,

    '_Acf_ContentBlocks_AgentProfileHeroBanner' : () => <AgentProfileHeroBanner key={i} {...el} />,
    '_Acf_ContentBlocks_AgentProfileProperties' : () => <AgentProfileProperties key={i} {...el} />,
    '_Acf_ContentBlocks_AgentProfileAbout' : () => <AgentProfileAbout key={i} {...el} />,
    '_Acf_ContentBlocks_AgentProfileContact' : () => <AgentProfileContact key={i} {...el} />,
    '_Acf_ContentBlocks_AgentProfileImageContent' : () => <AgentProfileImageContent key={i} {...el} />,
    '_Acf_ContentBlocks_AgentProfileAwards' : () => <AgentProfileAwards key={i} {...el} />,
    '_Acf_ContentBlocks_AgentProfileTeam' : () => <AgentProfileTeam key={i} {...el} />,
    '_Acf_ContentBlocks_AgentFullWidthButton' : () => <AgentFullWidthButton key={i} {...el} />,
    '_Acf_ContentBlocks_AgentPodcast' : () => <AgentPodcast key={i} {...el} />,
    '_Acf_ContentBlocks_AgentVideos' : () => <AgentVideos key={i} {...el} />,
    '_Acf_ContentBlocks_AgentPostsBlock' : () => <AgentPostsBlock key={i} {...el} />,
    '_Acf_ContentBlocks_ContactPopup' : () => <ContactPopup key={i} {...el} />,
  }[param]

  if (!block) return null

  return block(el, i)
}

export default renderBlock